import { createContext, ReactNode,useContext, useState } from 'react'

interface MobileSheetContextType {
  isMobileSheetOpen: boolean
  setIsMobileSheetOpen: (isOpen: boolean) => void
}

const MobileSheetContext = createContext<MobileSheetContextType | undefined>(
  undefined
)

export function MobileSheetProvider({ children }: { children: ReactNode }) {
  const [isMobileSheetOpen, setIsMobileSheetOpen] = useState(false)

  return (
    <MobileSheetContext.Provider
      value={{ isMobileSheetOpen, setIsMobileSheetOpen }}
    >
      {children}
    </MobileSheetContext.Provider>
  )
}

export function useMobileSheet() {
  const context = useContext(MobileSheetContext)
  if (context === undefined) {
    throw new Error('useMobileSheet must be used within a MobileSheetProvider')
  }
  return context
}
